export default [
  {
    id: 'wq6ocln',
    category: 'Salary',
    amount: 1200.27,
    isIncome: true,
    date: '12.02.2022',
    description: 'This is some comment to this',
  },
  {
    id: '1680at0',
    category: 'Salary',
    amount: 1200.27,
    isIncome: true,
    date: '12.02.2022',
    description: 'This is another comment',
  },
  {
    id: 'axg1grk',
    category: 'Bills',
    amount: 150.23,
    isIncome: false,
    date: '15.02.2022',
    description: 'This is definetely a comment',
  },
  {
    id: 'xzdgzxx',
    category: 'Salary',
    amount: 1200.27,
    isIncome: true,
    date: '12.02.2022',
    description: 'This is some comment to this',
  },
  {
    id: 'ico6eax',
    category: 'Groceries',
    amount: 1200.27,
    isIncome: false,
    date: '12.02.2022',
    description: 'This is another comment',
  },
  {
    id: 'b666j4i',
    category: 'Travel',
    amount: 400.23,
    isIncome: false,
    date: '12.02.2022',
    description: 'This is definetely a comment',
  },
];
